export var cilSpaceBar = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='40 288 40 416 464 416 464 288 432 288 432 384 72 384 72 288 40 288' class='ci-primary'/>"];
